import Icon from '../components/Icon.vue'

Icon.register({
  'money-check-alt': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M608 32c17.7 0 32 14.3 32 32v384c0 17.7-14.3 32-32 32h-576c-17.7 0-32-14.3-32-32v-384c0-17.7 14.3-32 32-32h576zM176 327.9c23.6-0.6 42.7-20.5 42.7-45.1 0-20-13-37.8-31.6-43.4l-45-13.5c-5.2-1.5-8.8-6.8-8.8-12.7 0-7.3 5.3-13.2 11.8-13.2h28.1c4.6 0 8.9 1.3 12.8 3.7 3.2 2 7.4 1.9 10.1-0.7l11.8-11.2c3.5-3.4 3.3-9.2-0.6-12.1-9.1-6.8-20.1-10.8-31.4-11.3v-16.3c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v16.1c-23.6 0.6-42.7 20.5-42.7 45.1 0 20 13 37.8 31.6 43.4l45 13.5c5.2 1.5 8.8 6.8 8.8 12.7 0 7.3-5.3 13.2-11.8 13.2h-28.1c-4.6 0-9-1.3-12.8-3.7-3.2-2-7.4-1.9-10.1 0.7l-11.8 11.2c-3.5 3.4-3.3 9.2 0.6 12.1 9.1 6.8 20.1 10.8 31.4 11.3v16.3c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-16.1zM416 312v-16c0-4.4-3.6-8-8-8h-112c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h112c4.4 0 8-3.6 8-8zM576 312v-16c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8zM576 216v-16c0-4.4-3.6-8-8-8h-272c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h272c4.4 0 8-3.6 8-8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/money-check-alt.js
// module id = 1579
// module chunks = 0